module.exports = __webpack_public_path__ + "assets/0aa42b39a82ef6a23252f840aedb123f.png";